import { memo } from "react";

import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";
import { type ProductHeroSettings } from "@root/tablescape/state";

import { ProductValuePropsView } from "./ProductValueProps.view";

const ProductValuePropsBase = () => {
  const {
    productValueProps,
    settings: { lazyLoadImages },
  } = useSectionSettings<ProductHeroSettings>();

  return (
    <ProductValuePropsView
      lazyLoadImages={lazyLoadImages}
      productValueProps={productValueProps}
    />
  );
};

export const ProductValueProps = memo(ProductValuePropsBase);
